import { yupResolver } from '@hookform/resolvers/yup';
import dayjs from 'dayjs';
import { useState } from 'react';
import { FieldValues, useForm } from 'react-hook-form';
import { UseExtendedFormProps, UseExtendedFormReturn } from '../type';

export default function useExtendedForm<TFieldValues extends FieldValues = FieldValues, TContext = AnyValue>({
  validationSchema,
  validateAfterSubmitted,
  ...props
}: UseExtendedFormProps<TFieldValues, TContext>): UseExtendedFormReturn<TFieldValues, TContext> {
  const [lastUpdated, setLastUpdated] = useState<number | null>(null);

  const args = useForm<TFieldValues, TContext>({
    mode: 'all',
    resolver: validationSchema ? yupResolver(validationSchema) : undefined,
    ...props,
  }) as UseExtendedFormReturn<TFieldValues, TContext>;

  args.lastUpdated = lastUpdated;
  args.displayErrorMessage = validateAfterSubmitted ? args.formState.isSubmitted : true;
  args.setValues = (values: TFieldValues) => {
    args.reset(values, {
      keepValues: false,
      keepIsSubmitted: true,
      keepDefaultValues: true,
      keepErrors: true,
      keepSubmitCount: true,
      keepDirty: true,
      keepTouched: true,
    });
    args.trigger();
    setLastUpdated(dayjs().valueOf());
  };

  return args;
}
